import { Segment } from '@mairistem/composants';

import ProduitsListe from './ProduitsListe';

const ParametrageProduits = () => (
  <Segment style={{ height: '100%' }}>
    <ProduitsListe />
  </Segment>
);

export default ParametrageProduits;
